import { useTranslation } from 'react-i18next';
import { DateRangeFilter } from '../../components/date-range-filter';
import dayjs from 'dayjs';

export function OccupancyRateMenu({
  selectedDate,
  selectedEndDate,
  onChange,
  onExportExcel,
  exporting,
}: {
  selectedDate: Date;
  selectedEndDate: Date;
  onChange?: (startDate: Date, endDate: Date) => void;
  onExportExcel?: () => void;
  exporting?: boolean;
}) {
  const { t } = useTranslation('reporting');

  const options = [
    {
      id: 'currentVsPreviousYear',
      label: t('currentVsPreviousYear'),
      startDate: dayjs().startOf('year').toDate(),
      endDate: dayjs().endOf('year').toDate(),
    },
    {
      id: 'custom',
      label: t('custom'),
      startDate: selectedDate,
      endDate: selectedEndDate,
    },
  ];

  return (
    <DateRangeFilter
      options={options}
      onChange={(dateRange) => {
        if (onChange) {
          onChange(dateRange[0], dateRange[1]);
        }
      }}
      onExportExcel={onExportExcel}
      exporting={exporting}
      initialStartDate={selectedDate}
      initialEndDate={selectedEndDate}
    />
  );
}
